export default __webpack_public_path__ + "static/media/blood-pressure.fe314569.svg";